import { getCompletionPercent } from "./completionPercent";
import type { Raffle, RaffleBase } from "./types";

export type RaffleProgressSource = Partial<
  Pick<RaffleBase, "volume_done_usdt" | "volume_usdt">
> &
  // completion есть в promos / search / detail; в recent — только объёмы.
  Partial<Pick<Raffle, "completion">>;

// Прогресс зрителя по условиям; null — данных нет (превью формы).
export const getRaffleProgress = (
  raffle: RaffleProgressSource,
): number | null => {
  if (raffle.completion) return getCompletionPercent(raffle.completion);
  if (raffle.volume_done_usdt === undefined || !raffle.volume_usdt) {
    return null;
  }
  return getCompletionPercent({
    volume_done_usdt: raffle.volume_done_usdt,
    volume_required_usdt: raffle.volume_usdt,
  });
};

// Хоть 1% выполнен. Без требования по объёму не считаем: там 100% у всех.
export const hasStartedConditions = (
  raffle: Pick<RaffleBase, "volume_done_usdt" | "volume_usdt">,
): boolean =>
  Number(raffle.volume_usdt) > 0 && (getRaffleProgress(raffle) ?? 0) >= 1;
